import { r as registerInstance, h } from './index-BntG-4Sv.js';
import { CancelDialogAction } from '@ontotext/workbench-api';
import { T as TranslationService } from './translation.service-CyWR_ReZ.js';

const ontoConfirmCancelDialogCss = ".confirm-cancel-dialog .dialog{padding:0}.confirm-cancel-dialog .dialog .dialog-header{border-bottom:1px solid var(--gw-dialog-border-color)}.confirm-cancel-dialog .dialog .dialog-header .close-btn{color:var(--gw-message-close-button-color)}.confirm-cancel-dialog .dialog .dialog-header .close-btn:hover,.confirm-cancel-dialog .dialog .dialog-header .close-btn:focus{color:var(--gw-button-secondary-hover-color);text-decoration:none;cursor:pointer;transform:scale(1.2)}.confirm-cancel-dialog .dialog .dialog-body{padding:15px;flex:1;min-height:0;overflow:auto;font-size:1.25rem;font-weight:300}.confirm-cancel-dialog .dialog .dialog-footer{border-top:1px solid var(--gw-dialog-border-color);gap:0.25rem}.confirm-cancel-dialog .dialog-overlay{align-self:baseline;background:none}@media (width >= 768px){.confirm-cancel-dialog .dialog{width:600px;margin:30px auto}}";

const OntoConfirmCancelDialog = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.isOpen = false;
        this.hasDontShowAgain = false;
        this.onCancel = () => this.resolve(CancelDialogAction.CANCEL);
        this.onExit = () => this.resolve(CancelDialogAction.EXIT);
        this.onDontShowAgain = () => this.resolve(CancelDialogAction.DONT_SHOW_AGAIN);
    }
    onConfirmCancelEvent(event) {
        this.hasDontShowAgain = event.detail.hasDontShowAgain;
        this.onClose = event.detail.onClose;
        this.isOpen = true;
    }
    render() {
        if (!this.isOpen) {
            return null;
        }
        const config = {
            dialogTitle: TranslationService.translate('guides.confirm-cancel-modal.title'),
            onClose: this.onCancel,
        };
        return (h("onto-dialog", { "data-test": 'confirm-cancel-dialog', class: 'confirm-cancel-dialog', config: config }, h("div", { slot: "body" }, h("span", { innerHTML: TranslationService.translate('guides.confirm-cancel-modal.subtitle') })), h("button", { slot: 'footer', class: "onto-btn onto-btn-secondary", "data-test": 'cancel-btn', onClick: this.onCancel }, h("translate-label", { labelKey: 'common.button.cancel' })), this.hasDontShowAgain && (h("button", { slot: 'footer', class: "onto-btn onto-btn-secondary", "data-test": 'dont-show-again-btn', onClick: this.onDontShowAgain }, h("translate-label", { labelKey: 'guides.confirm-cancel-modal.dont-show-again' }))), h("button", { slot: 'footer', class: "onto-btn onto-btn-primary", "data-test": 'exit-btn', onClick: this.onExit }, h("translate-label", { labelKey: 'guides.confirm-cancel-modal.exit-button' }))));
    }
    resolve(action) {
        var _a;
        this.isOpen = false;
        (_a = this.onClose) === null || _a === void 0 ? void 0 : _a.call(this, action);
    }
};
OntoConfirmCancelDialog.style = ontoConfirmCancelDialogCss;

export { OntoConfirmCancelDialog as onto_confirm_cancel_dialog };
